import { defineComponent as _defineComponent } from 'vue'
import { FLAG_IMPRESSIONS_POSTS } from "@/utils/experiments/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'TrackPostImpression',
  setup(__props) {


return { __sfc: true,FLAG_IMPRESSIONS_POSTS }
}

})